import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
// import './tooltip.scss';
import "../../assets/css/tooltip.scss";

function Tooltips({ delay,typing, ...props  }) {
  let timeout;
  const [active, setActive] = useState(false);
  const [leftPosition, setLeftPosition] = useState();
  const [topPosition, setTopPosition] = useState();
  const tooltipContainer = useRef(null);

  const showTip = (e) => {
    timeout = setTimeout(() => {
      const rectangle = e.target.getBoundingClientRect();
      const tooltipHeight = tooltipContainer?.current?.offsetHeight;
      const tooltipWidth = tooltipContainer?.current?.offsetWidth;
      switch (props.direction) {
        case "right":
          setLeftPosition(rectangle.x + rectangle.width);
          setTopPosition(
            rectangle.y + rectangle.height / 2 - tooltipHeight / 2 - 3
          );
          setActive(true);
          break;
        case "top":
          setLeftPosition(
            rectangle.x + rectangle.width / 2 - tooltipWidth / 2 - 3
          );
          setTopPosition(rectangle.y - tooltipHeight);
          setActive(true);
          break;
        case "left":
          setLeftPosition(rectangle.x - tooltipWidth);
          setTopPosition(
            rectangle.y + rectangle.height / 2 - tooltipHeight / 2 - 3
          );
          setActive(true);
          break;
        case "center":
          setLeftPosition(
            rectangle.x + rectangle.width / 2 - tooltipWidth / 2 - 3
          );
          setTopPosition(rectangle.y + rectangle.height);
          setActive(true);
          break;
        default:
          setLeftPosition(
            rectangle.x + rectangle.width / 2 - tooltipWidth / 2 - 6
          );
          setTopPosition(rectangle.y + rectangle.height);
          setActive(true);
      }
    }, delay || 100);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <div
      className="tooltip-wrapper"
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {props.children}
      {(props.content && (props.content).trim() !== "") && !typing && (
        <div
          className={`tooltip-tip ${props.direction || "bottom"} ${
            active ? "show" : ""
          }`}
          style={{ left: leftPosition, top: topPosition }}
        >
          <span ref={tooltipContainer}>{props.content}</span>
        </div>
      )}
    </div>
  );
}

export default Tooltips;
Tooltips.propTypes = {
  delay: PropTypes.string,
  direction: PropTypes.string,
  content: PropTypes.string,
  children: PropTypes.node.isRequired,
};
Tooltips.defaultProps = {
  delay: "",
  direction: "",
  content: "",
};
